import lang from "src/assets/lang.json";
import iso from "src/assets/iso.json";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { Router } from "@angular/router";
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { GetCalendars, ListProductItem } from "src/app/core/services/outbound";
import {
  user_role_color_map,
  user_role_map,
  user_search_placeholder_map,
  user_status_color_map,
  user_status_map,
} from "src/app/core/services/constants";
import { formatDate } from "@angular/common";

@Component({
  selector: "app-calendars-selector",
  templateUrl: "./calendars-selector.component.html",
  styleUrls: ["./calendars-selector.component.scss"],
  providers: [],
})

/**
 * Contacts domain-list component
 */
export class CalendarsSelectorComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() mode = "list";
  @Input() single = false;
  @Input() selectedCalendars = [];
  @Output() selectedNotifier = new EventEmitter<any>();
  @Output() cancelNotifier = new EventEmitter<boolean>(false);
  // bread crumb items
  breadCrumbItems: Array<{}>;
  page: Array<any> = [];
  eop = false;
  pageSize = 24;
  currentPage = 0;
  calendarList: {};
  listCalendarsSubscription: any;
  monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  status_map = {};
  status_color_map = {};
  user_search_placeholder_map = {};
  user_role_map = {};
  user_role_color_map = {};
  payload = {};
  calendarListForm: UntypedFormGroup;
  submitted = false;
  dupe = false;
  criterionCount = 0;
  component_ref: any;
  search_message = "";
  countries = [];
  loading = false;
  verifySubscription: any;
  my_id: any;

  selectedProductsList = {};

  constructor(
    private ws: WebsocketService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private mdw: MiddlwareService,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit() {
    // console.log(this.router.url);
    this.countries = iso.map((a) => a.name);
    this.status_map = user_status_map;
    this.status_color_map = user_status_color_map;
    this.user_role_map = user_role_map;
    this.user_role_color_map = user_role_color_map;
    this.user_search_placeholder_map = user_search_placeholder_map;

    // console.log(this.countries);
    this.component_ref = this.mdw.makeRef(16);
    this.currentPage = 1;
    this.calendarList = {};
    // console.log(Object.keys(this.userList).length);

    this.calendarListForm = this.formBuilder.group({
      chat_id: new UntypedFormControl(null),
      created_date: new UntypedFormControl(null),
      search_type: new UntypedFormControl("name"),
      search_value: new UntypedFormControl(null),
      status: new UntypedFormControl(""),
    });

    this.listCalendarsSubscription = this.ws.listCalendarsContainer$.subscribe((listCalendarsData) => {
      if (listCalendarsData.ref === this.component_ref) {
        if (listCalendarsData) {
          this.loading = false;
          // console.log("in");
          // console.log(Object.keys(this.userList).length);
          this.currentPage = listCalendarsData.page_number;
          if (
            listCalendarsData.calendars.length == 0 &&
            this.currentPage == 1
          ) {
            this.search_message = "No results matched your search criteria";
          }

          listCalendarsData.calendars.forEach((channel: any) => {
            channel.created_date = new Date(channel.created_date);
            channel.created_date =
              channel.created_date.getDate() +
              " " +
              this.monthNames[channel.created_date.getMonth()] +
              ", " +
              channel.created_date.getFullYear();
            // channel.country_alpha = iso.find((e) => e.code == channel.country_code)?.alpha;

            this.calendarList[String(channel.id)] = channel;
          });
          // console.log(Object.keys(this.userList).length);

          this.page = [];
          for (let i = 0; i < this.pageSize; i++) {
            if (
              Object.keys(this.calendarList)[
                i + (this.currentPage - 1) * this.pageSize
              ]
            ) {
              this.page.push(
                this.calendarList[
                  Object.keys(this.calendarList)[
                    i + (this.currentPage - 1) * this.pageSize
                  ]
                ]
              );
            }
          }

          document
            .getElementById("pagination_back")
            .classList.remove("d-none");
          document
            .getElementById("pagination_back")
            .classList.add("enablePointer");
          document
            .getElementById("pagination_next")
            .classList.remove("d-none");
          document
            .getElementById("pagination_next")
            .classList.add("enablePointer");

          this.eop = false;
          if (listCalendarsData.eop) {
            this.eop = true;
            document
              .getElementById("pagination_next")
              .classList.add("d-none");
            document
              .getElementById("pagination_next")
              .classList.remove("enablePointer");
          } else {
            document
              .getElementById("pagination_next")
              .classList.remove("d-none");
            document
              .getElementById("pagination_next")
              .classList.add("enablePointer");
          }
          if (this.currentPage == 1) {
            document
              .getElementById("pagination_back")
              .classList.add("d-none");
            document
              .getElementById("pagination_back")
              .classList.remove("enablePointer");
          } else {
            document
              .getElementById("pagination_back")
              .classList.remove("d-none");
            document
              .getElementById("pagination_back")
              .classList.add("enablePointer");
          }
          if (this.currentPage == 1 && listCalendarsData.eop) {
            document
              .getElementById("showPageNumber")
              .classList.add("invisible");
          } else {
            document
              .getElementById("showPageNumber")
              .classList.remove("invisible");
          }
          this.ref.detectChanges();
        }
      }
    });

    this.verifySubscription = this.ws.verifyContainer$.subscribe((verifyData) => {
      // console.log("verifyData"+ verifyData);
      if (verifyData) {
        this.my_id = this.mdw.getID();
        this.loading = true;
        this.ws.processMethod(new GetCalendars(0, this.component_ref));
      }
    });

    if (this.selectedCalendars && this.selectedCalendars.length > 0) {
      for (let i = 0; this.selectedCalendars.length > i; i++) {
        this.selectedProductsList[this.selectedCalendars[i].id] =
          this.selectedCalendars[i];
      }
    }

    this.breadCrumbItems = [
      { label: "MENUITEMS.STOREMANGER.TEXT" },
      { label: "PRODUCTS.PRODUCTS", active: true },
    ];
  }

  ngOnDestroy(): void {
    // console.log("destroy");
    if (this.listCalendarsSubscription) {
      this.listCalendarsSubscription.unsubscribe();
    }
    if (this.verifySubscription) {
      this.verifySubscription.unsubscribe();
    }
  }

  ngAfterViewInit(): void {
    document.getElementById("pagination_back").classList.add("d-none");
    document
      .getElementById("pagination_back")
      .classList.remove("enablePointer");
    document.getElementById("pagination_next").classList.add("d-none");
    document
      .getElementById("pagination_next")
      .classList.remove("enablePointer");
  }

  openDetails(data: any) {
    this.router.navigate([
      "/" +
        data.account_id +
        "/" +
        data.ref_domain +
        "/" +
        data.service.product,
    ]);
  }

  get f() {
    return this.calendarListForm.controls;
  }

  onSubmit() {
    this.loading = true;

    let id = this.f.search_type.value === "calendar" ? this.f.search_value.value : null;
    let name = this.f.search_type.value === "name" ? this.f.search_value.value : null;
    let created_date = this.f.created_date.value;
    this.search(id, name, created_date);
  }

  search(id: any, name: any, created_date: any) {
    this.currentPage = 0;
    this.calendarList = {};
    this.payload = {};
    this.search_message = "";

    this.payload = {
      page_size: this.pageSize,
      page_number: 0,
    };

    if (id != null && id !== "") {
      this.payload["calendar_id"] = id;
    }
    if (name != null && name !== "") {
      this.payload["name"] = name;
    }
    if (created_date != null && created_date !== "") {
      let dateStr = formatDate(created_date, 'yyyy-MM-dd', 'en-US');
      this.payload["created_date"] = dateStr;
    }

    this.ws.processMethod(
      new GetCalendars(
        0,
        this.component_ref,
        this.payload['calendar_id'],
        this.payload['name'],
        this.payload['created_date']
      )
    );
  }

  nextPage() {
    // console.log("request");
    this.payload["page_size"] = this.pageSize;
    this.payload["page_number"] = this.currentPage;
    this.payload["chat_id"] = localStorage.getItem("chat_id");

    this.ws.processMethod(
      new GetCalendars(
        this.currentPage,
        this.component_ref,
        this.payload['calendar_id'],
        this.payload['name'],
        this.payload['created_date']
      )
    );
  }

  backPage() {
    if (this.currentPage != 1) {
      this.currentPage--;
      this.page = [];
      for (let i = 0; i < this.pageSize; i++) {
        if (
          Object.keys(this.calendarList)[
            i + (this.currentPage - 1) * this.pageSize
          ]
        ) {
          this.page.push(
            this.calendarList[
              Object.keys(this.calendarList)[
                i + (this.currentPage - 1) * this.pageSize
              ]
            ]
          );
        }
      }
      if (this.currentPage == 1) {
        document.getElementById("pagination_back").classList.add("d-none");
        document
          .getElementById("pagination_back")
          .classList.remove("enablePointer");
      }
      if (
        this.currentPage <
        Object.keys(this.calendarList).length / this.pageSize
      ) {
        document.getElementById("pagination_next").classList.remove("d-none");
        document
          .getElementById("pagination_next")
          .classList.add("enablePointer");
      }
    }
  }

  selectProduct(data) {
    // console.log(data);
    if (this.single) {
      if (this.selectedProductsList[data.id]) {
        delete this.selectedProductsList[data.id];
      } else {
        this.selectedProductsList = {};
        this.selectedProductsList[data.id] = data;
      }
    } else {
      if (this.selectedProductsList[data.id]) {
        delete this.selectedProductsList[data.id];
      } else {
        this.selectedProductsList[data.id] = data;
      }
    }
  }

  insertEvent() {
    const selected = Object.values(this.selectedProductsList);
    // console.log(selected);
    this.selectedNotifier.emit(selected);
  }

  cancelEvent() {
    this.cancelNotifier.emit(true);
  }

  isObjEmpty() {
    return Object.keys(this.selectedProductsList).length === 0;
  }

  isSelected(id: string) {
    return this.selectedProductsList[id] ? true : false;
  }
}
